// extracted by mini-css-extract-plugin
module.exports = {"component":"GoogleButton_component__2QLHh","logo":"GoogleButton_logo__2JcMn"};